import { z, ZodType } from "zod";
import { IAkustikkPremissRapport } from "./akustikk/akustikkPremissrapportSchema.js";
import { IBrannkoseptRapport } from "./brannkonseptSchema.js";
import { IBygningsfysikkPremissRapport } from "./bygningsfysikk/bygningsfysikkPremissrapport/bygningsfysikkPremissrapportSchema.js";
import { IEksempelrapport } from "./eksempelRapportSchema.js";
import { IElektroSamsvarserklaringEkomnettRapport } from "./elektroSamsvarserklaringEkomnettSchema.js";
import { IElektroSamsvarserklaringFELRapport } from "./elektroSamsvarserklaringFELSchema.js";
import { IGeoTeknikkRapport } from "./geoteknikSchema.js";
import { IGKRapport } from "./gkReportSchema.js";
import { IInternJuridiskUnderkonsulentRapport } from "./internJuridiskSchema.js";
import { ISJArapport } from "./sjaSchema.js";
import { IOverleveringChecklistReport } from "../startupChecklists/templates/901-overlevering/901Schema.js";
import { IForenkletStyringNivaa1Report } from "../startupChecklists/templates/902-forenklet-styring/902InitialData.js";

export interface IReportTemplateAdmin {
  _id?: string;
  name?: string;
  email?: string;
  picture?: string;
}

export interface IReportTemplate {
  templateId?: number;
  name: string;
  description?: string;
  admin?: IReportTemplateAdmin;
  data: object;
  enabledForUser: boolean;
  domainsWithAccess?: string[];
  zodSchema?: ZodType;
}

export const ZReportTemplateId = z.union([
  z.literal(101),
  z.literal(102),
  z.literal(103),
  z.literal(104),
  z.literal(106),
  z.literal(201),
  z.literal(202),
  z.literal(205),
  z.literal(301),
  z.literal(401),
  z.literal(601),
  z.literal(701),
  z.literal(901),
  z.literal(902),
]);

export type ReportCode = 101 | 102 | 103 | 104 | 106 | 201 | 202 | 205 | 301 | 401 | 701 | 901 | 902;

export type IReportKeyData = {
  101: IEksempelrapport | null;
  102: IBrannkoseptRapport | null;
  103: IGeoTeknikkRapport | null;
  104: IGKRapport | null;
  106: IGeoTeknikkRapport | null;
  201: IElektroSamsvarserklaringFELRapport | null;
  202: IElektroSamsvarserklaringEkomnettRapport | null;
  205: ISJArapport | null;
  301: IBygningsfysikkPremissRapport | null;
  401: IAkustikkPremissRapport | null;
  701: IInternJuridiskUnderkonsulentRapport | null;
  901: IOverleveringChecklistReport | null;
  902: IForenkletStyringNivaa1Report | null;
};
